import { CARD_DETAIL_HERO_DEMO } from './cardDetailHeroDemoData'

/**
 * The shape every hero region reads from. Today it is exactly the demo
 * constant; when the real data effort lands it becomes the composed response
 * shape, and only this file changes.
 */
export type CardDetailHeroData = typeof CARD_DETAIL_HERO_DEMO

/**
 * Single data seam for the card detail hero.
 *
 * Region components MUST read card values through this hook rather than
 * importing `CARD_DETAIL_HERO_DEMO` directly. Everything it returns is
 * fabricated demo data today — see the guardrail in
 * `.nightshift/plans/2026-07-20-card-mgmt-header.md` §2.5: the hero must never
 * be enabled in a customer-facing environment while that is true.
 *
 * The return value is grouped by *source*, not by consumer: `card`, `limits`,
 * and `billing` are three independently fetched endpoints in the approved API
 * contract, and the card detail response deliberately carries identity and
 * capabilities rather than a duplicated aggregate of all feature data.
 *
 * Wiring real data therefore means replacing each group with its own query
 * here — keeping their failure and refresh windows isolated — while every
 * region component and its tests stay untouched. Regions should destructure
 * only the groups they use, so a group gaining loading/error state later is a
 * change to its own consumers and no one else's.
 */
export const useCardDetailHeroData = (): CardDetailHeroData =>
  CARD_DETAIL_HERO_DEMO
